import { getFilterConfig } from '../../../utils/filter';
import { FILTER } from '../../../data/enums/filter';
import { reports as reportsRoute } from '../../../data/enums/Route';

const title = 'Time Spent On Route';

const breadCrumb = [reportsRoute];

const filter = getFilterConfig([FILTER.STL, FILTER.ASM, FILTER.SUB_D]);

export {
  breadCrumb as breadCrumbConfig, filter as filterConfig, title
};
